//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.section`
    padding: 35px;
    padding-top: 10px;
    padding-bottom: 10px;
    display: flex;
    flex-direction: column;
    gap: 20px;
`;